<template>
  <div id="farms">

    <!--Farms drawer -->
    <b-card
      id="farmsCard"
      class="blockDrawer large"
      :class="$store.state.drawer.farms.position"
    >
      <template v-slot:header>
        <a
          class="close clickable"
          @click="$store.commit('hideDrawer', 'farms')"
        >
          <i class="far fa-times"></i>
        </a>
        <h4 class="card-title">My Farms</h4>
        <b-btn
          @click="createFarm()"
          class="mb-2"
        >
          <i class="far fa-plus"></i> New Farm
        </b-btn>
      </template>

      <!-- SEARCH BOX -->
      <VueFuse
        v-if="$store.state.farms.length > 1 && showSearch"
        :fuseOpts="fuseOptions"
        :list="$store.state.farms"
        placeholder="Search Farms"
        class="text-center border rounded-lg center mb-2 w-100"
        @fuse-results="handleResults"
      />
      <!-- PINNED LIST OF FARMS -->
      <div class="list-group mb-2">
        <div
          v-for="(farm, i) in pinnedResults"
          v-bind:key="i"
          class="list-group-item list-group-item-action"
        >
          <div class="d-flex w-100 justify-content-between">
            <small
              @click="launchFarm(farm.item.id)"
              class="clickable"
            >
              <strong>{{ farm.item.role }}</strong>
            </small>
            <div class="card-right-group">
              <small
                v-b-tooltip.hover
                v-if="farm.item.role !== 'Owner'"
                title="Leave this Farm"
                class="mr-2 text-danger clickable"
                @click="confirmLeaveFarm(farm.item)"
              >
                <i class="fas fa-user-slash"></i>
              </small>
              <small
                v-if="farm.item.id == $store.state.userProfile.defaultFarm"
                v-b-tooltip.hover
                title="Default Farm"
                class="text-success mr-2"
              >
                <i class="fas fa-heart"></i>
              </small>
              <small
                v-else
                v-b-tooltip.hover
                title="Set Default Farm"
                @click="setDefaultFarm(farm.item.id)"
                class="text-success clickable mr-2"
              >
                <i class="far fa-heart"></i>
              </small>
              <!-- PIN THE FARM -->
              <small
                v-if="$store.state.userProfile.pinnedFarms || $store.state.userProfile.pinnedFarms.includes(farm.item.id)"
                v-b-tooltip.hover
                title="Unpin Farm"
                class="text-success clickable"
                @click="unPinFarm(farm.item.id)"
              >
                <i class="fas fa-thumbtack"></i>
              </small>
            </div><!-- /.card-right-group -->
          </div>
          <p @click="launchFarm(farm.item.id)" class="lead mb-1 clickable">{{ farm.item.name }}</p>
        </div><!-- /Farm Card-->
      </div><!-- /.list-group -->

      <!-- STANDARD LIST OF FARMS -->
      <div class="list-group">
        <div
          v-for="(farm, i) in farmsResults"
          v-bind:key="i"
          class="list-group-item list-group-item-action"
        >
          <div class="d-flex w-100 justify-content-between">
            <small
              @click="launchFarm(farm.item.id)"
              class="clickable"
            >
              <strong>{{ farm.item.role }}</strong>
            </small>
            <div class="card-right-group">
              <small
                v-b-tooltip.hover
                v-if="farm.item.role !== 'Owner'"
                title="Leave this Farm"
                class="mr-2 text-danger clickable"
                @click="confirmLeaveFarm(farm.item)"
              >
                <i class="fas fa-user-slash"></i>
              </small>
              <small
                v-if="farm.item.id == $store.state.userProfile.defaultFarm"
                v-b-tooltip.hover
                title="Default Farm"
                class="text-success mr-2"
              >
                <i class="fas fa-heart"></i>
              </small>
              <small
                v-else
                v-b-tooltip.hover
                title="Set Default Farm"
                @click="setDefaultFarm(farm.item.id)"
                class="text-success clickable mr-2"
              >
                <i class="far fa-heart"></i>
              </small>
              <!-- PIN THE FARM -->
              <small
                v-if="!$store.state.userProfile.pinnedFarms || !$store.state.userProfile.pinnedFarms.includes(farm.item.id)"
                v-b-tooltip.hover
                title="Pin Farm to Top"
                class="text-success clickable"
                @click="pinFarm(farm.item.id)"
              >
                <i class="far fa-thumbtack"></i>
              </small>
            </div><!-- /.card-right-group -->
          </div>
          <p @click="launchFarm(farm.item.id)" class="lead mb-1 clickable">{{ farm.item.name }}</p>
        </div><!-- /Farm Card-->
      </div><!-- /.list-group -->
    </b-card>
    <Confirm
      v-if="confirmLeaveFarmPrompt"
      text="DANGER! Are you sure you want to leave this farm? You will have to contact the farm owner if you want them to add you back!"
      v-on:confirmed="leaveFarm($event)"
    />
  </div><!-- /#farms -->
</template>

<script>
import VueFuse from 'vue-fuse'
import Confirm from '../Confirm.vue'
const fb = require('../../firebaseConfig.js')

export default {
  data () {
    return {
      confirmLeaveFarmPrompt: false,
      farmsResults: [],
      pinnedResults: [],
      farmToLeave: false,
      fuseOptions: {
        keys: ['name']
      },
      showSearch: true
    }
  },
  components: {
    Confirm,
    VueFuse
  },
  methods: {
    unPinFarm (farmId) {
      this.showSearch = false
      console.log('Unpin')
      const pins = this.$store.state.userProfile.pinnedFarms || []
      const newPins = []
      pins.forEach(pin => {
        if (pin !== farmId) {
          newPins.push(pin)
        }
      })
      console.log(newPins)
      fb.usersCollection.doc(this.$store.state.currentUser.uid).update({
        pinnedFarms: newPins,
        updatedOn: new Date()
      }).then(() => {
        this.$store.dispatch('fetchUserProfile')
        console.log('Unpinned')
        this.showSearch = true
      })
    },
    pinFarm (farmId) {
      this.showSearch = false
      console.log('Pin')
      const pins = this.$store.state.userProfile.pinnedFarms || []
      pins.push(farmId)
      fb.usersCollection.doc(this.$store.state.currentUser.uid).update({
        pinnedFarms: pins,
        updatedOn: new Date()
      }).then(() => {
        this.$store.dispatch('fetchUserProfile')
        console.log('Pinned')
        this.showSearch = true
      })
    },
    handleResults (r) {
      this.farmsResults = []
      this.pinnedResults = []
      r.forEach(result => {
        if (this.$store.state.userProfile.pinnedFarms && this.$store.state.userProfile.pinnedFarms.includes(result.item.id)) {
          this.pinnedResults.push(result)
        } else {
          this.farmsResults.push(result)
        }
      })
    },
    confirmLeaveFarm (farm) {
      this.farmToLeave = farm
      this.confirmLeaveFarmPrompt = true
    },
    leaveFarm (confirmed) {
      console.log(this.$store.state.currentUser.uid)
      console.log(confirmed)
      if (confirmed) {
        this.showSearch = false
        delete this.farmToLeave.permissions[this.$store.state.currentUser.uid]
        for (let index = this.farmToLeave.users.length - 1; index >= 0; index--) {
          if (this.farmToLeave.users[index].id === this.$store.state.currentUser.uid) {
            this.farmToLeave.users.splice(index, 1)
          }
        }
        fb.farmsCollection.doc(this.farmToLeave.id).update({
          updatedOn: new Date(),
          updatedBy: this.$store.state.currentUser.uid,
          permissions: this.farmToLeave.permissions,
          users: this.farmToLeave.users
        }).then(() => {
          console.log('Farm Updated. Updating Profile')
          const pins = this.$store.state.userProfile.pinnedFarms || []
          const newPins = []
          pins.forEach(pin => {
            if (pin !== this.farmToLeave.id) {
              newPins.push(pin)
            }
          })
          let defaultFarm = this.$store.state.userProfile.defaultFarm
          if (this.$store.state.userProfile.defaultFarm === this.farmToLeave.id) {
            defaultFarm = false
          }
          return fb.usersCollection.doc(this.$store.state.currentUser.uid).update({
            updatedOn: new Date(),
            pinnedFarms: newPins,
            defaultFarm: defaultFarm
          })
        }).then(() => {
          this.$store.dispatch('fetchFarms')
          this.$store.commit('setAlert', { active: true, message: 'Successfully removed yourself from ' + this.farmToLeave.name + '.', level: 'alert-success', timeout: 8000 })
          this.$store.dispatch('fetchUserProfile')
          this.showSearch = true
        })
      }
      console.log(this.farmToLeave)
      this.confirmLeaveFarmPrompt = false
    },
    setDefaultFarm (id) {
      fb.usersCollection.doc(this.$store.state.currentUser.uid).update({
        defaultFarm: id
      }).then(() => {
        this.$store.dispatch('fetchUserProfile')
      })
    },
    launchFarm (id) {
      window.location.href = '/f/' + id
    },
    createFarm () {
      this.$store.commit('hideDrawer', 'farms')
      setTimeout(() => {
        this.$store.commit('setEditMode', false)
        this.$store.commit('showDrawer', 'createFarm')
        // this.$store.commit('toggleModal', 'createFarm')
      }, 300)
    }
  }
}
</script>

<style scoped>
  /* #mapsCard {
    overflow-y: scroll;
  } */
</style>
